export function tags(state = {}, action) {
  switch (action.type) {
    case 'SET_TAGS':
      return { ...state, ...action.tags };
    case 'SET_TAG': {
      const newTags = { ...state };
      newTags[action.tag.id] = action.tag;
      return { ...state, ...newTags };
    }
    case 'OPTIMISTIC_TAG_FOLLOW': {
      const optiTags = { ...state };
      const followers = optiTags[action.id].stats.followers;
      optiTags[action.id].following = action.follow;
      optiTags[action.id].stats.followers = action.follow ? followers + 1 : followers - 1;
      return { ...state, ...optiTags };
    }
    default:
      return state;
  }
}
